import { getDecodedShopifyProductIdString } from "@utils/index"
import React from "react"
import { v4 as uuidv4 } from "uuid"

const ATTENTIVE_VIEW_ITEM = "attentive_view_item"

export interface AttentiveProductProps {
  brand: string
  device: string
  deviceType: string
  image?: string
  price: string
  productId: string
  productName: string
  sku: string
  variantId: string
  variantName: string
}

const formatAttentiveProduct = ({
  brand,
  device,
  deviceType,
  image,
  price,
  productId,
  productName,
  sku,
  variantId,
  variantName,
}: AttentiveProductProps) => {
  const product: any = {
    brand,
    category: `${deviceType} / ${device}`,
    name: productName,
    price,
    productId: getDecodedShopifyProductIdString(productId),
    sku,
    variantId: variantId,
  }

  if (image) {
    product.image = image
  }

  if (variantName) {
    product.variant = variantName
  }

  return product
}

const getDataLayer = (): any[] | undefined => {
  if (typeof window === "undefined") {
    return undefined
  }

  const w = window as any
  w.dataLayer = w.dataLayer || []
  return w.dataLayer
}

export default () => {
  const dataLayer = getDataLayer() as any

  if (dataLayer) {
    dataLayer.attentive_product_view = dataLayer.attentive_product_view || []
  }

  // Required: variantName, image, inventory, list
  // Trigger every time a different variant is selected
  const attentiveOnViewItem = React.useCallback(
    (product: AttentiveProductProps) => {
      if (dataLayer) {
        dataLayer.attentive_product_view.push({
          ecommerce: {
            currencyCode: "USD",
            detail: {
              products: [formatAttentiveProduct(product)],
            },
          },
          event: ATTENTIVE_VIEW_ITEM,
          event_id: uuidv4(),
        })
      }
    },
    [dataLayer]
  )

  return {
    attentiveOnViewItem,
  }
}
